import { Component, OnInit, ViewChild, Input, SimpleChanges, OnChanges, AfterViewChecked } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HighlightService } from '../../services/highligh.service';

@Component({
  selector: 'app-code-render',
  templateUrl: './code-render.component.html',
  styleUrls: ['./code-render.component.scss']
})
export class CodeRenderComponent implements OnInit, OnChanges, AfterViewChecked {
  @ViewChild('editor', { static: false }) editor: any;
  highlighted: boolean = false;

  comment: any;
  sanitizeComponent: any;
  @Input() renderCode : boolean;
  @Input() component: any;
  @Input() titulo: any;
  @Input() subtitulo: any;
  @Input() id: any;
  utils: any;
  @Input() arrayComponents: any;

  constructor(
    private sanitizer: DomSanitizer,
    private highlightService: HighlightService) {
    this.utils = window.utils;
  }

  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.utils.init();
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  }

  ngOnInit() {
    
  }


  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes.component !== 'undefined') {
      this.comment = this.component;
      this.sanitizeComponent = this.sanitizer.bypassSecurityTrustHtml(this.comment);
    }

    if (typeof changes.arrayComponents !== 'undefined') {
      this.utils.init();
      this.arrayComponents = this.arrayComponents.map((component: any) => {
        return {
          ...component,
          ...{ sanitizeComponent: this.sanitizer.bypassSecurityTrustHtml(component.componentRender) },
          ...{ sanitizeFalseComponent: typeof component.componentFalseRender !== 'undefined' ? 
          this.sanitizer.bypassSecurityTrustHtml(component.componentFalseRender): false },
          ...{ subtituloSanitize: this.sanitizer.bypassSecurityTrustHtml(component.subtitulo) },
          ...{ descripcionComponentSanitize: typeof component.descripcionComponent !== 'undefined' ?
          this.sanitizer.bypassSecurityTrustHtml(component.descripcionComponent): false },
          ...{ descripcionList: typeof component.descripcionList !== 'undefined' ?
          component.descripcionList: false },
          ...{ codejsTab: typeof component.codejs !== 'undefined' ? { id: component.id, js: component.codejs} : false,
          }
        }
      });
    }
  }

}
